<template>
<div>
<ContentHeader title="Soru Sütunu"  url="QuestionColumns" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri" :urlparams="headerurlparams"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<form @submit.prevent="submitForm" class="mt-4" v-if="languages.length">



<div class="grid" >
<div class="col-12 md:col-12">
<InputTextValidate :data="fields[0]" :fieldindex="0" @emitValue="inputValueEmitted"></InputTextValidate>
</div>


<div class="col-12 md:col-12">
<InputSelectValidate :data="fields[2]" :fieldindex="2" @emitValue="inputValueEmitted"></InputSelectValidate>
</div>

<div class="col-12 md:col-12 ">
<InputSelectValidate :data="fields[9]" :fieldindex="9" @emitValue="inputValueEmitted"></InputSelectValidate>
</div>

<div class="col-12 md:col-12 ">
<InputSwitchValidate :data="fields[10]" :fieldindex="10" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>


<div class="col-12 md:col-12">
<InputNumberValidate :data="fields[1]" :fieldindex="1" @emitValue="inputValueEmitted"></InputNumberValidate>
</div>

<div class="col-12 md:col-12">
<InputSwitchValidate :data="fields[3]" :fieldindex="3" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>

<div class="col-12 md:col-12">
<InputSwitchValidate :data="fields[8]" :fieldindex="8" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>

<div class="col-12 md:col-12">
<InputNumberValidate :data="fields[15]" :fieldindex="15" @emitValue="inputValueEmitted"></InputNumberValidate>
</div>

<div class="col-12 md:col-12">
<InputNumberValidate :data="fields[4]" :fieldindex="4" @emitValue="inputValueEmitted"></InputNumberValidate>
</div>

<div class="col-12 md:col-12">
<InputNumberValidate :data="fields[5]" :fieldindex="5" @emitValue="inputValueEmitted"></InputNumberValidate>
</div>

<div class="col-12 md:col-12">
<InputNumberValidate :data="fields[6]" :fieldindex="6" @emitValue="inputValueEmitted"></InputNumberValidate>
</div>

<div class="col-12 md:col-12">
<InputNumberValidate :data="fields[7]" :fieldindex="7" @emitValue="inputValueEmitted"></InputNumberValidate>
</div>

<div class="col-12 md:col-12">
<InputSwitchValidate :data="fields[11]" :fieldindex="11" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>

<div class="col-12 md:col-12">
<InputSwitchValidate :data="fields[12]" :fieldindex="12" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>

<div class="col-12 md:col-12">
<InputSwitchValidate :data="fields[13]" :fieldindex="13" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>

<div class="col-12 md:col-12 mb-2" v-if="fields[13].value">
<InputNumberValidate :data="fields[14]" :fieldindex="14" @emitValue="inputValueEmitted"></InputNumberValidate>
</div>


<template v-if="fields[2].value && fields[2].value.id=='custom'">
<CalculationRoot :questionlists="questionlists" :nodesdata="item.calculation"></CalculationRoot>
</template>



<template v-if="fields[2].value && fields[2].value.id=='select' && $route.params.column_id">
<ColumnOptions :options="item.options" :languages="languages" @optionsUpdated="optionsUpdated"></ColumnOptions>
</template>




</div>

<template v-if="show_translations">
<Toolbar class="mb-6">
<template #start>
<h4 class="text-primary mb-2 mt-2 font-medium">Sütun Çevirileri</h4>
</template>
</Toolbar>



<div class="grid" v-for="(item,index) in languages">
<div class="col-12 md:col-12">
<InputTextValidate :data="translationfields[index]" :fieldindex="index" @emitValue="translationValueEmitted"></InputTextValidate>
</div>
</div>  
</template>


<template v-if="show_readonly_translations">
<Toolbar class="mb-6">
<template #start>
<h4 class="text-primary mb-2 mt-2 font-medium">Sadece Okunur Çevirileri</h4>
</template>
</Toolbar>



<div class="grid" v-for="(item,index) in languages">
<div class="col-12 md:col-12">
<InputTextValidate :data="readonlytranslationfields[index]" :fieldindex="index" @emitValue="readonlytranslationValueEmitted"></InputTextValidate>
</div>
</div>  
</template>











<div class="flex justify-content-end flex-wrap mt-3">
 <Button label="Kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" type="submit"></Button>
</div>



</form>
</template>

</div>
</template>

<script>
import ColumnOptions from "./ColumnOptions"
export default {

  name: 'QuestionColumn',
  components:{ColumnOptions},
  data () {
    return { 
    calculation_object:{
      id:null,
      inputfield_id:null,
      column_id:null,
      questionlist_id:null,
      slug:null,
    },
    fields:[
        {
          title:"İsim",
          key:"name",
          type:"text",
          value:null,
          min_length:1,
          max_length:500,
          is_required:true,
          has_error:false,
          error_message:null,
          show:true,
        },
        {
          title:"puan %",
          key:"points",
          type:"number",
          value:0,
          is_required:false,
          steps:1,
          show:true
        },
        {
          title:"Tür",
          key:"type",
          type:"select",
          value:null,
          is_required:true,
          has_error:false,
          error_message:null,
          show:true,
          options:[
          {
            name:"Text",
            id:"text"
          },
          {
            name:"Sayı",
            id:"number"
          },
          {
            name:"Sadece Okunur",
            id:"readonly"
          },
          {
            name:"Özel",
            id:"custom"
          },
          {
            name:"Seçim",
            id:"select"
          },
          ],
        },
        {
          title:"Gerekli",
          key:"is_required",
          type:"switch",
          value:false,
          show:true,
        },
        {
          title:"Min Değer",
          key:"min_value",
          type:"number",
          value:null,
          is_required:false,
          steps:1,
          show:false
        },
        {
          title:"Max Değer",
          key:"max_value",
          type:"number",
          value:null,
          is_required:false,
          steps:1,
          show:false
        },
        {
          title:"Min Karakter Sayısı",
          key:"min_char_length",
          type:"number",
          value:null,
          is_required:false,
          steps:1,
          show:false
        },
        {
          title:"Max Karakter Sayısı",
          key:"max_char_length",
          type:"number",
          value:null,
          is_required:false,
          steps:1,
          show:false
        },
        {
          title:"Aktif",
          key:"active",
          type:"switch",
          value:false,
          show:true,
        },      
        {
          title:"Doğrulama Tipi",
          key:"validation_type",
          type:"select",
          value:{name:"Yok",id:"none"},
          is_required:false,
          has_error:false,
          error_message:null,
          show:false,
          options:[
          {name:"Yok",id:"none"},
          {name:"Email",id:"email"},
          {name:"Bağlantı",id:"link"},
          {name:"Tarih",id:"date"},
          ],
        },
        {
          title:"Marka Veri Girişlerinde Göster",
          key:"show_on_graphs",
          type:"switch",
          value:false,
          show:true,
        }, 
        {
          title:"Bölme ve çarpmada 1 kullan",
          key:"calculate_with_zero",
          type:"switch",
          value:false,
          show:true,
        },
        {
          title:"Sonucu VT'ye Ekle",
          key:"submit_to_db",
          type:"switch",
          value:false,
          show:true,
        },
        {
          title:"Hesaplama Sonucunu puan olarak kullan",
          key:"result_as_points",
          type:"switch",
          value:false,
          show:true,
        },      
        {
          title:"Max Hesaplanabilir Puan",
          key:"max_calculated_points",
          type:"number",
          value:0,
          is_required:false,
          steps:1,
          show:true
        },     
        {
          title:"Max Küsürat",
          key:"allowed_fraction",
          type:"number",
          value:8,
          is_required:false,
          steps:1,
          show:true
        },
      ],
      translationfields:[],
      readonlytranslationfields:[],
      languages:[],
      questionlists:[],
      inputfields:[],
      columns:[],
      show_translations:false,
      show_readonly_translations:false,
      item:{calculation:null,calculation_objects:[],options:[]},
      loading:true,
      selectedquestionlist:null,
      selectedinputfield:null,
      selectedcolumn:null,
      column_extensions:[],
      adding_variable:false,
      loading_inputfields:true,
      loading_columns:true,
    }
  },
  computed:{
    headerurlparams()
    {
      return {id:this.$route.params.id}
    }
  },
  async mounted()
  {
  	await this.getProjectLanguages()
    await this.getQuestionlists()
  	if(this.$route.params.column_id)
  	{
  		await this.getData()
  	}
  	this.loading = await false
  },
  methods:{
    optionsUpdated(data)
    {
      this.item.options = data
    },
    addVariable()
    {
      this.adding_variable = true
    },
    cancelVariable()
    {
      this.selectedinputfield = null
      this.selectedquestionlist = null
      this.selectedcolumn = null
      this.adding_variable = false
      this.calculation_object = {
        id:null,
        inputfield_id:null,
        column_id:null,
        questionlist_id:null,
        slug:null,
      }

      console.log(this.item)
    },
    async questionlistSelected()
    {
      console.log(this.selectedquestionlist)
      this.loading_inputfields = true
      let inputfields = await this.generalApiGetWithoutLoader("questionlists/inputfields_for_calculation/"+this.selectedquestionlist)
      console.log("inputfields")
      console.log(inputfields)
      for(let inputfield of inputfields)
      {
          if(inputfield.name.length>30)
          {
              inputfield.name = await inputfield.name.substring(0, 30);
          }
          
      }
      this.inputfields  = await inputfields
      this.loading_inputfields = await false
    },
    async inputfieldSelected()
    {
      let inputfield = this.inputfields.find((item)=>{return item.id == this.selectedinputfield})
      if(inputfield.type=="columns")
      {
        this.loading_columns = await true
        let columns = await this.generalApiGetWithoutLoader("questionlists/inputfield_columns_for_calculation/"+this.selectedinputfield)
        for(let column of columns)
        {
            if(column.name.length>30)
            {
                column.name = await column.name.substring(0, 30);
            }
            
        }
        this.columns  = await columns
        this.loading_columns = await false
      }
      else
      {
        let slug = await inputfield.name
        let calculation_object = await this.sanitizeArray(this.calculation_object)
        calculation_object.id = await Math.floor(Date.now() / 1000)
        calculation_object.inputfield_id = await this.selectedinputfield
        calculation_object.questionlist_id = await this.selectedquestionlist


        let prev = await this.item.calculation_objects.findIndex((item)=>{return item.slug == slug})        
        if(prev!==-1)
        {
          slug = await slug+"I"
        }
        calculation_object.slug = await slug
        await this.item.calculation_objects.push(calculation_object)

        let tag ='&nbsp;<span class="p-tag p-component mr-2 ml-2"   ['+slug+']>'+slug+'</span></span >&nbsp;'
        let calculation = this.$refs.calculation
        this.$refs.calculation.innerHTML = calculation.innerHTML + tag
        this.item.calculation = this.$refs.calculation.innerHTML
        this.cancelVariable()
      }
      
    },
    columnSelected()
    {
      let column = this.columns.find((item)=>{return item.id == this.selectedcolumn})
      let inputfield = this.inputfields.find((item)=>{return item.id == this.selectedinputfield})

      let slug =  inputfield.name+"-"+column.name
      let calculation_object =  this.sanitizeArray(this.calculation_object)
      calculation_object.id =  Math.floor(Date.now() / 1000)
      calculation_object.inputfield_id =  this.selectedinputfield
      calculation_object.column_id =  this.selectedcolumn
      calculation_object.questionlist_id =  this.selectedquestionlist

      let prev =  this.item.calculation_objects.findIndex((item)=>{return item.slug == slug})        
      if(prev!==-1)
      {
        slug =  prev.slug+"I"
      }
      calculation_object.slug =  slug
      this.item.calculation_objects.push(calculation_object)



      let tag ='&nbsp;<span class="p-tag p-component mr-2 ml-2" ['+slug+']><span class="p-tag-value" >'+slug+'</span></span>&nbsp;'
      let calculation = this.$refs.calculation
      this.$refs.calculation.innerHTML = calculation.innerHTML + tag
      this.item.calculation = this.$refs.calculation.innerHTML
      this.cancelVariable()

    },
    addHtml()
    {
      
      let calculation = this.$refs.calculation
      console.log(this.$refs.calculation.innerHTML)

      let html_text = this.$refs.calculation.innerHTML
      let html_arr = html_text.split('&nbsp;');
      
      console.log(html_arr)
      this.item.calculation = calculation.innerHTML
    },
  	async getData()
  	{
  		this.item = await this.generalApiGetWithoutLoader("questionlists/inputfield/column/"+this.$route.params.column_id)
      console.log(this.item)
  		if(this.item.calculation_objects && this.item.calculation_objects!=="")
      {
        
        this.item.calculation_objects = await JSON.parse(this.item.calculation_objects)
      }
      else
      {
        
        this.item.calculation_objects = await []
      }

  		
  		await setTimeout(async ()=>{
  			this.fields[0].value = await this.item.name

        if(this.item.is_required)
        {
          this.fields[3].value = await true
        }
        else
        {
          this.fields[3].value = await false
        }

        if(this.item.active)
        {

          this.fields[8].value = await true
        }
        else
        {
          this.fields[8].value = await false
        }

        if(this.item.show_on_graphs)
        {

          this.fields[10].value = await true
        }
        else
        {
          this.fields[10].value = await false
        }

        if(this.item.calculate_with_zero)
        {

          this.fields[11].value = await true
        }
        else
        {
          this.fields[11].value = await false
        }

        if(this.item.submit_to_db)
        {

          this.fields[12].value = await true
        }
        else
        {
          this.fields[12].value = await false
        }

        if(this.item.result_as_points)
        {

          this.fields[13].value = await true
        }
        else
        {
          this.fields[13].value = await false
        }

        if(this.item.max_calculated_points)
        {

          this.fields[14].value = await this.item.max_calculated_points
        }

        if(this.item.allowed_fraction)
        {

          this.fields[15].value = await this.item.allowed_fraction
        }

        
        
  		  this.fields[1].value = await parseFloat(this.item.points)
        if(this.item.type=="text")
        {
          this.fields[2].value = await {name:"Text",id:"text"}
          this.fields[6].show = await true
          this.fields[6].value = await this.item.min_char_length
          this.fields[7].show = await true
          this.fields[7].value = await this.item.max_char_length
          this.fields[9].show = await true
          this.fields[10].show = false
          this.fields[11].show = false
          this.fields[12].show = false
          this.fields[13].show = false
          this.fields[15].show = false
          let selected_val = this.fields[9].options.find((item)=>{return item.id == this.item.validation_type})
          this.fields[9].value = await this.sanitizeArray(selected_val)
        }
        if(this.item.type=="number")
        {
          this.fields[2].value = await {name:"Sayı",id:"number"}
          this.fields[4].show = await true
          this.fields[4].value = await this.item.min_value 
          this.fields[5].show = await true
          this.fields[5].value = await this.item.max_value 
          this.fields[11].show = false 
          this.fields[12].show = false
          this.fields[13].show = false
          this.fields[15].show = true

        }
        if(this.item.type=="custom")
        {
          this.fields[2].value = await {name:"Özel",id:"custom"}
          
          this.fields[3].show = await false
          this.fields[10].show = false
          this.fields[11].show = true
          this.fields[12].show = true
          this.fields[13].show = true
          this.fields[15].show = true
          //this.$refs.calculation.innerHTML = await this.item.calculation
          //this.show_readonly_translations = true
        }
        if(this.item.type=="readonly")
        {
          this.fields[2].value = await {name:"Sadece Okunur",id:"readonly"}
          
          this.fields[3].show = false
          this.fields[10].show = true
          this.fields[11].show = false
          this.fields[12].show = false
          this.fields[13].show = false
          this.fields[15].show = false
          this.show_readonly_translations = true
        }
        if(this.item.type=="select")
        {
          this.fields[2].value = await {name:"Seçim",id:"select"}          
          this.fields[15].show = false
        }
        

  			for(let element of this.item.translations)
	  		{
	  			let ind = await this.translationfields.findIndex((item)=>{return item.language_id == element.language_id})
	  			
	  			this.translationfields[ind].value = await element.translation
          this.translationfields[ind].id = await element.id

          this.readonlytranslationfields[ind].value = await element.readonly
          this.readonlytranslationfields[ind].id = await element.id
	  		}
        await console.log("iterm")
        await console.log(this.item);
  		})
  		
  		await console.log(this.translationfields)
  	},
    async getQuestionlists()
    {
      console.log("getQuestionlists")
      console.log(this.$route.params.id)

      //return false
      let questionlists = await this.generalApiGetWithoutLoader("questionlists/brand_questionlists/"+this.$route.params.id)
      await console.log(questionlists)
      for(let questionlist of questionlists)
      {
          if(questionlist.name.length>30)
          {
              questionlist.name = questionlist.name.substring(0, 30);
          }
          
      }
      this.questionlists  = questionlists

    },
  	 async getProjectLanguages()
  	 {
  	 	console.log(this.$store.state.questions.question.project_id)
  	 	this.languages = await this.generalApiGetWithoutLoader("project/languages/"+this.$store.state.questions.question.project_id)
  	 	console.log("languages")
  	 	console.log(this.languages)
  	 	for(let item of this.languages)
  	 	{
  	 		let obj = await 
          {
              title:item.name+" için çeviri",
              key:item.id,
              type:"text",
              language_id:item.id,
              value:null,
              is_required:true,
              has_error:false,
              error_message:null,
              show:true,
            }
       await this.translationfields.push(obj)

       let readonlyobj = await 
          {
              title:item.name+" sadece okunur değeri",
              key:item.id,
              type:"text",
              language_id:item.id,
              value:null,
              is_required:true,
              has_error:false,
              error_message:null,
              show:true,
            }
       await this.readonlytranslationfields.push(readonlyobj)




  	 	}
  	 	console.log(this.translationfields)
  	 	this.show_translations = await true
  	 },
  	 submitForm()
    {
        console.log(this.fields)
        let validated = this.validateForm(this.fields)
        if(!validated.has_error)
        {
          this.submit()
        }
        console.log(validated)
    },
    inputValueEmitted(data)
    { 
      console.log("inputValueEmitted");
      console.log(data);
      this.fields[data.index].value = data.value 
      this.fields[data.index].has_error = false
      if(data.index==2)
      {
        if(data.value.id=="readonly" || data.value.id=="custom")
        {
          this.show_readonly_translations = true
          this.fields[3].show = false
          this.fields[4].show = false
          this.fields[5].show = false
          this.fields[6].show = false
          this.fields[7].show = false
          
          if(data.value.id=="readonly" )
          {

            this.fields[11].show = false 
            this.fields[12].show = false  
            this.fields[13].show = false  
            this.fields[10].show = true
          }
          else
          {
            this.fields[10].show = false  
            this.fields[11].show = true  
            this.fields[12].show = true   
            this.fields[13].show = true 
            
          }
        }
        else if(data.value.id=="select" )
        {
          this.fields[3].show = false
          this.fields[4].show = false
          this.fields[5].show = false
          this.fields[6].show = false
          this.fields[7].show = false  
          this.fields[11].show = false 
          this.fields[12].show = false 
          this.fields[13].show = false  
          this.fields[10].show = false
        }
        else
        {
          this.show_readonly_translations = false
          this.fields[3].show = true
          if(data.value.id=="text")
          {
            this.fields[6].show = true
            this.fields[7].show = true 
            this.fields[4].show = false
            this.fields[5].show = false
            this.fields[9].show = true
            this.fields[10].show = false  
            this.fields[11].show = false  
            this.fields[12].show = false  
            this.fields[13].show = false  
          }
          if(data.value.id=="number")
          {
            this.fields[4].show = true
            this.fields[5].show = true  
            this.fields[6].show = false
            this.fields[7].show = false  
            this.fields[9].show = false  
            this.fields[10].show = false   
            this.fields[11].show = false   
            this.fields[12].show = false   
            this.fields[13].show = false   
          }
        }
        
      }

      


     
    },
    translationValueEmitted(data)
    {
      this.translationfields[data.index].value = data.value 
    },
    readonlytranslationValueEmitted(data)
    {
      this.readonlytranslationfields[data.index].value = data.value 
    },
    submit()
    {       

      console.log(this.fields)
      //return false
      let formdata = this.createFormData(JSON.parse(JSON.stringify(this.fields)))

      formdata.append("translations",JSON.stringify(this.translationfields))
      formdata.append("readonlytranslations",JSON.stringify(this.readonlytranslationfields))

      formdata.append("inputfield_id",this.$route.params.id) 
      let nodes = this.$store.state.calculations.nodes
      let connections = this.$store.state.calculations.connections
      let calculation = {nodes:nodes,connections:connections}
      formdata.append("calculation",JSON.stringify(calculation))
      if(this.$route.params.column_id)
      {
      	this.generalSubmission(formdata,"questionlists/inputfield/columns/update/"+this.$route.params.column_id,this.afterSubmit)
      } 
      else
      {
      	this.generalSubmission(formdata,"questionlists/inputfield/columns/store",this.afterSubmit)
      }
      
    },
    afterSubmit(response)
    {
        console.log(response)
        this.$router.push({ name: 'QuestionColumns'})
        if(response.status==400)
        {
            this.showerror = true
            this.errormessage = response.data.errors[0].message
        }
        else
        {
        	
        }
      
    },
  }
};
</script>

<style lang="css" scoped>
</style>